import { render, staticRenderFns } from "./linkpay.vue?vue&type=template&id=e832a4ec&scoped=true&"
import script from "./linkpay.vue?vue&type=script&lang=js&"
export * from "./linkpay.vue?vue&type=script&lang=js&"
import style0 from "./linkpay.vue?vue&type=style&index=0&id=e832a4ec&scoped=true&lang=css&"
import style1 from "./linkpay.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e832a4ec",
  null
  
)

export default component.exports